module.exports = __webpack_public_path__ + "img/syukyaku-top-ira002.c94c311a.png";